<template>
  <div class="StudyItem" @click="$emit('click')">
    <div class="card">
      <van-image class="img" :src="item.defaultImage" fit="cover"></van-image>
      <div class="content">
        <div class="title">{{item.title}}</div>
        <div class="subTitle">{{item.digest}}</div>
        <div class="date">{{item.createTime | formatDate('yyyy-MM-dd hh:mm')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="less" scoped>
.StudyItem {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  .card {
    width: 336px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .img {
      width: 336px;
      height: 224px;
    }
    .content {
      padding: 16px 20px;
      .title {
        font-size: 26px;
        color: #333444;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .subTitle {
        margin-top: 4px;
        font-size: 22px;
        font-weight: 500;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .date {
        margin-top: 14px;
        font-size: 22px;
        font-weight: 400;
        color: #999AAA;
      }
    }
  }
}
</style>